import React from 'react'
import styles from './index.module.css'

const ButtonBlock = ({
  link,
  caption,
  style,
}: {
  link: string
  caption: string
  style: Record<string, any>
}): React.ReactElement<'div'> => (
  <div className={styles.emailButtonContainer}>
    <a
      className={styles.emailButtonContainerButton}
      style={style}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      {caption}
    </a>
  </div>
)

export default ButtonBlock
